var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCropFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6V3.33333C2 2.6 2.6 2 3.33333 2H6V3.33333H3.33333V6H2ZM2 10H3.33333V12.6667H6V14H3.33333C2.6 14 2 13.4 2 12.6667V10ZM12.6667 12.6667H10V14H12.6667C13.4 14 14 13.4 14 12.6667V10H12.6667V12.6667ZM10 2H12.6667C13.4 2 14 2.6 14 3.33333V6H12.6667V3.33333H10V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30236 5.54321C7.27543 5.14089 7.59587 4.7998 8.00078 4.7998C8.40831 4.7998 8.72968 5.14514 8.69872 5.5498L8.44268 8.89619C8.42562 9.11919 8.23894 9.29147 8.01435 9.29147H7.95518C7.72903 9.29147 7.54161 9.11686 7.52656 8.89215L7.30236 5.54321Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98287 11.2165C8.33874 11.2165 8.62723 10.9292 8.62723 10.5748C8.62723 10.2204 8.33874 9.93314 7.98287 9.93314C7.627 9.93314 7.33851 10.2204 7.33851 10.5748C7.33851 10.9292 7.627 11.2165 7.98287 11.2165Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropFree);
export default __webpack_public_path__ + "static/media/cropFree.cb2c4b55dcb8c26d47016c1f31a03ebe.svg";
export { ForwardRef as ReactComponent };